'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _reduxForm = require('redux-form');

var _reactIntl = require('react-intl');

var _reactGoogleRecaptcha = require('react-google-recaptcha');

var _reactGoogleRecaptcha2 = _interopRequireDefault(_reactGoogleRecaptcha);

var _reactRedux = require('react-redux');

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _feedbackValidation = require('./feedbackValidation');

var _feedbackValidation2 = _interopRequireDefault(_feedbackValidation);

var _helpers = require('./../../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./FormFeedback.scss');

var FormFeedback = (_dec = (0, _reactRedux.connect)(function (state) {
  var app = state.app.get('app');
  var appId = _immutable2.default.Map.isMap(app) ? app.get('id') : app.id;
  return {
    initialValues: { appId: appId }
  };
}), _dec2 = (0, _reduxForm.reduxForm)({
  form: 'feedback',
  fields: ['name', 'email', 'content', 'recaptcha', 'appId'],
  validate: _feedbackValidation2.default
}), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(FormFeedback, _Component);

  function FormFeedback() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FormFeedback);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FormFeedback.__proto__ || (0, _getPrototypeOf2.default)(FormFeedback)).call.apply(_ref, [this].concat(args))), _this), _this.handleRecaptchaChange = function (value) {
      var recaptcha = _this.props.fields.recaptcha;

      recaptcha.onChange(value);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FormFeedback, [{
    key: 'renderSubmitButton',
    value: function renderSubmitButton() {
      var _props = this.props,
          isLoading = _props.isLoading,
          handleSubmit = _props.handleSubmit;

      var attrs = {
        className: 'btn btn-primary ' + styles.btnSend,
        onClick: handleSubmit
      };

      if (isLoading) {
        attrs.disabled = 'disabled';
      }

      if (isLoading) {
        return _react2.default.createElement(
          'button',
          attrs,
          _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement('i', { className: 'fa fa-cog fa-spin fa-fw' }),
            _react2.default.createElement(
              'span',
              null,
              'Loading...'
            )
          )
        );
      }

      return _react2.default.createElement(
        'button',
        attrs,
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'send' })
      );
    }
  }, {
    key: 'renderMessage',
    value: function renderMessage() {
      var err = this.props.err;


      if (err) {
        return _react2.default.createElement(
          _reactBootstrap.Alert,
          { bsStyle: 'danger' },
          _react2.default.createElement(
            'h4',
            null,
            'Oh snap ! You got an error !'
          ),
          _react2.default.createElement(
            'p',
            null,
            'string' === typeof err ? err : err.message
          )
        );
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          fields = _props2.fields,
          handleSubmit = _props2.handleSubmit;
      var name = fields.name,
          email = fields.email,
          content = fields.content,
          recaptcha = fields.recaptcha,
          appId = fields.appId;


      var classSubmitBtnWrap = (0, _classnames2.default)({
        'form-group': true,
        clearfix: true
      });

      return _react2.default.createElement(
        'form',
        { className: 'form-horizontal ' + styles.formFeedback, onSubmit: handleSubmit },
        this.renderMessage(),
        (0, _helpers.renderFormControl)({ field: name, type: 'text', labelId: 'name' }),
        (0, _helpers.renderFormControl)({ field: email, type: 'text', labelId: 'email' }),
        (0, _helpers.renderFormControl)({ field: content, type: 'textarea', labelId: 'feedback-content' }),
        (0, _helpers.renderFormControl)({ field: appId, type: 'hidden' }),
        _react2.default.createElement(_reactGoogleRecaptcha2.default, { ref: 'recaptchaImage', sitekey: '6LeEOA8UAAAAAEonUYj_iKsKZH9kTv5rfeszaqbj', onChange: this.handleRecaptchaChange }),
        recaptcha.error && recaptcha.touched && _react2.default.createElement(
          'div',
          { className: 'text-danger' },
          recaptcha.error
        ),
        _react2.default.createElement(
          'div',
          { className: classSubmitBtnWrap },
          this.renderSubmitButton()
        )
      );
    }
  }]);
  return FormFeedback;
}(_react.Component), _class2.propTypes = {
  err: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.object]),
  fields: _react.PropTypes.object.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired,
  isLoading: _react.PropTypes.bool.isRequired
}, _temp2)) || _class) || _class);
exports.default = FormFeedback;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/FormFeedback/FormFeedback.js
 ** module id = 1229
 ** module chunks = 0
 **/